import { useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation } from 'graphql/hooks.generated'

import { ConfiguracaoBooleanBox } from '../ConfiguracaoBooleanBox'

interface ConfiguracoesBloqueioFcdtViaCdsBoxProps {
  habilitado: boolean
}

export function ConfiguracoesBloqueioFcdtViaCdsBox({ habilitado }: Readonly<ConfiguracoesBloqueioFcdtViaCdsBoxProps>) {
  const [alterarConfiguracao] = useAlterarConfiguracaoCadastroDomiciliarViaCdsMutation()

  return (
    <ConfiguracaoBooleanBox
      title='Cadastros de imóveis e famílias via CDS'
      description='Pode comprometer a qualidade dos cadastros em relação à consistência dos núcleos familiares. O Acompanhamento do território já substitui e otimiza esse fluxo, inibindo a ocorrência de inconsistências e facilitando a gestão dos cadastros.'
      habilitado={habilitado}
      modalBody='Isso pode aumentar a ocorrência de inconsistências nos núcleos familiares. Recomendamos que o município utilize o Acompanhamento do território, que provê todas as funcionalidades que existiam na Ficha de Cadastro Domiciliar do CDS e ainda fornece meios para qualificação dos cadastros.'
      successMsgHabilitado='Cadastros de imóveis e famílias via CDS habilitadas com sucesso'
      successMsgDesabilitado='Cadastros de imóveis e famílias via CDS desabilitadas com sucesso'
      onMutation={(input) => alterarConfiguracao({ variables: { input } })}
    />
  )
}
